import { $convertFromMarkdownString, TextMatchTransformer, Transformer } from '@lexical/markdown';
import { $getRoot, $isParagraphNode } from 'lexical';
import {
  $createRightAlignedMarkNode,
  $isRightAlignedMarkNode,
  RightAlignedMarkNode,
} from '../../nodes/RightAlignedMarkNode';

export const createRightAlignedTransformer = (
  transformers: Transformer[],
): TextMatchTransformer => ({
  type: 'text-match',
  dependencies: [RightAlignedMarkNode],
  importRegExp: /\[([^\]]+)\]\{\.RightAlignedText\}/,
  regExp: /\[([^\]]+)\]\{\.RightAlignedText\}/,
  replace: (textNode, match) => {
    const inner = match[1];

    const tempContainer = $createRightAlignedMarkNode();
    $getRoot().append(tempContainer);
    $convertFromMarkdownString(inner, transformers, tempContainer, true);

    const parsedChildren = tempContainer.getChildren();
    const mark = $createRightAlignedMarkNode();
    if (parsedChildren.length === 1 && $isParagraphNode(parsedChildren[0])) {
      parsedChildren[0].getChildren().forEach(child => mark.append(child));
    } else {
      parsedChildren.forEach(child => mark.append(child));
    }
    tempContainer.remove();
    textNode.replace(mark);
  },
  export: (node, exportChildren) => {
    if (!$isRightAlignedMarkNode(node)) return null;
    return `[${exportChildren(node)}]{.RightAlignedText}`;
  },
});
